import React from 'react'
import _ from 'lodash'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar as farCalendar } from '@fortawesome/free-regular-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TytoSelect from '../../components/TytoSelect'
import FilterPopoutButton from '../../components/FilterPopoutButton'
library.add(farCalendar, faTimes)

const AdditionalFilters = props => {
  const handleSelectShowAllContent = val => props.setShowAllContent(val === 2)

  const handleToggleModuleId = id => props.toggleModuleId(id)

  const handleToggleContentType = typeId =>{
    const typeName = (_.find(props.typeOptions, op => op.value === typeId) || {}).label
    props.toggleContentType(typeName)
  }

  const getSelectedContentTypeIds = ()=>
    _.map(props.selectedContentTypes, type => (_.find(props.typeOptions, op => op.label === type) ||{}).value)

  return(
    <div style={{ marginTop: '10px' }}>
      <FilterPopoutButton
        title='Additional Filters'
        iconComponent={<FontAwesomeIcon icon='sliders-h'/>}
        onCancel={props.revertSelectedFilters}
        onApply={props.commitFilters}>

        <p>Showing progress from:</p>
        <TytoSelect
          selections={props.selectedProgressType ? 2 : 1}
          placeholderTextUsesSelection={true}
          options={[
            { value: 1, label: 'Assigned Content Only' },
            { value: 2, label: 'All Content' }
          ]}
          onSelect={handleSelectShowAllContent}
        />
        <p>You may select specific catagories with which to view the assignemnt progress for.</p>
        <p>You may select multiple options from each catagory.</p>
        <TytoSelect
          selections={props.selectedModuleIds}
          placeholder='Select Module'
          multiple={true}
          options={props.moduleOptions}
          onSelect={val=>handleToggleModuleId(val)}
        />
        <TytoSelect
          selections={getSelectedContentTypeIds()}
          placeholder='Select Type'
          multiple={true}
          options={props.typeOptions}
          onSelect={val=>handleToggleContentType(val)}
        />
        {_.map(props.selectedModuleIds, (value,index)=>
          <span key={index}
            className='selected-filter'
            onClick={()=>handleToggleModuleId(value)}>
            {(_.find(props.moduleOptions, op=>op.value == value) || {}).label}
            <FontAwesomeIcon icon='times'/>
          </span>
        )}
        {_.map(getSelectedContentTypeIds(), (value,index)=>
          <span key={index}
            className='selected-filter'
            onClick={()=>handleToggleContentType(value)}>
            {(_.find(props.typeOptions, op=>op.value == value) || {}).label}
            <FontAwesomeIcon icon='times'/>
          </span>
        )}
      </FilterPopoutButton>
    </div>
  );
}

export default AdditionalFilters
